import { ArrowUpRight } from "lucide-react";

// Links to the social posts that carry this piece, rendered at the end of an article.
export function SocialPosts({ links, isLight }) {
  const eyebrow = isLight ? "text-champagne" : "text-champagne";
  const rule = isLight ? "border-aubergine/10" : "border-champ-light/10";
  const chip = isLight
    ? "inline-flex items-center gap-2 rounded-full border border-aubergine/15 bg-bone-soft hover:border-champagne/60 hover:bg-bone transition-colors px-3.5 py-1.5 text-sm text-aubergine"
    : "inline-flex items-center gap-2 rounded-full border border-champ-light/15 bg-aubergine-tier hover:border-champagne/40 hover:bg-aubergine-raised transition-colors px-3.5 py-1.5 text-sm text-bone";
  const icon = isLight ? "text-aubergine/45" : "text-bone/45";

  return (
    <div className={`mt-14 border-t pt-8 ${rule}`} data-testid="article-social-posts">
      <p className={`font-mono text-[10px] uppercase tracking-[0.2em] ${eyebrow}`}>Also posted on</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {links.map((l, i) => (
          <a
            key={`${l.url}-${i}`}
            href={l.url}
            target="_blank"
            rel="noopener noreferrer"
            className={chip}
            data-testid={`article-social-link-${i}`}
          >
            {l.label}
            <ArrowUpRight className={`h-3.5 w-3.5 ${icon}`} />
          </a>
        ))}
      </div>
    </div>
  );
}
